import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const Text = styled(props =>
  <Typography variant='pb4' color='primary.main' {...props} />
)({
  fontWeight: 700,
  textTransform: 'uppercase',
});
